import React from 'react';
import PropTypes from 'prop-types';
import {MarkerCreateFuncs, OverlappingMarkerCreateFuncs} from '../../MapComponents';
import {getPolyLinesFromTemplateStopTemplates} from '../../../../services/util/mapUtils';
import {IconService, unassignedTemplateStopIconColor} from '../../../../services/icon/iconService';
import BaseTemplateStopTemplateMap from 'components/Maps/BaseMaps/BaseTemplateStopTemplateMap';

//  Map for Templates on the Template-Stop-Overview -> Templates
const TemplateStopTemplateMap = React.memo(props => {

  const {className, templates, unassignedTemplateStops, displayUnassignedTemplateStops, onSelectStop, onSelectUnassignedTemplateStop, displayControls, mapState, setMapState} = props;

  return (
    <BaseTemplateStopTemplateMap
      className={className}
      displayControls={displayControls}
      displayTemplateStops={displayUnassignedTemplateStops}
      getOverLappingMarkerClusterIcon={(overlappingElements, highLiteDuplicates) => OverlappingMarkerCreateFuncs.getForTemplateMap(overlappingElements, highLiteDuplicates)}
      getPolyLines={getPolyLinesFromTemplateStopTemplates}
      getTemplateStopClusterIcon={() => IconService.getMarkerClusterIcon(unassignedTemplateStopIconColor)}
      getUnassignedTemplateStopMarkerAndAddToMcg={(unassignedTemplateStop, mcg, t) => MarkerCreateFuncs.getUnassignedTemplateStopMarker({templateStop: unassignedTemplateStop, mcg, t,onSelectTemplateStop:  onSelectUnassignedTemplateStop})}
      getTemplateClusterIcon={(template) => IconService.getMarkerClusterIcon(template.color, template.id)}
      getTemplateStopMarkerAndAddToMcg={(template, templateStop, stopNumber, mcg, t) => MarkerCreateFuncs.getTemplateStopMarkerTemplateStop({template, templateStop, stopNumber, mcg, t, onSelectTemplateStop: onSelectStop})}
      unassignedTemplateStops={unassignedTemplateStops}
      templates={templates}
      mapState={mapState}
      setMapState={setMapState}
    />
  );
});

TemplateStopTemplateMap.displayName = 'TemplateStopTemplateMap';

TemplateStopTemplateMap.propTypes = {
  className: PropTypes.string,
  unassignedTemplateStops: PropTypes.array.isRequired,
  displayControls: PropTypes.bool,
  displayUnassignedTemplateStops: PropTypes.bool,
  onSelectUnassignedTemplateStop: PropTypes.func,
  onSelectStop: PropTypes.func,
  templates: PropTypes.array.isRequired,
  mapState: PropTypes.object.isRequired,
  setMapState: PropTypes.func.isRequired,
};

export default TemplateStopTemplateMap;

